/*
    React utility to merge refs
    Adapted from `react-merge-refs` package

    Source code: https://github.com/gregberge/react-merge-refs/blob/96ca3bf1feea0e9f0a4c6d5ca247882be3cba585/src/index.tsx 
    License (MIT): https://github.com/gregberge/react-merge-refs/blob/96ca3bf1feea0e9f0a4c6d5ca247882be3cba585/LICENSE
*/

/**
 * @template T
 * @param {import('react').Ref<T>[]} refs
 * @returns {import('react').Ref<T>}
 */
export function mergeRefs(refs) {
  return value => {
    refs.forEach(ref => {
      if (typeof ref === 'function') {
        ref(value);
      } else if (ref !== null && ref !== undefined) {
        ref.current = value;
      }
    });
  };
}